import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { isUserAuthenticatedSelector } from "Auth/state";
import { useGetBandInvitation } from "Bands/utils";
import { useHistory } from "react-router-dom";
import { Loader } from "shared/components";
import { StringParam, useQueryParams } from "use-query-params";
import { LoginOrRegister } from "./LoginOrRegister";
import { AcceptInvitation } from "./containers";

export const AcceptInvitationPage: React.FC = () => {
  const isUserAuthenticated = useSelector(isUserAuthenticatedSelector);

  const [query, setQuery] = useQueryParams({
    destination: StringParam,
  });

  const {
    location: { pathname, search },
  } = useHistory();

  const { bandInvitation } = useGetBandInvitation();

  useEffect(() => {
    if (!query.destination && !isUserAuthenticated)
      setQuery({ destination: encodeURIComponent(pathname + search) });
    if (query.destination && isUserAuthenticated)
      setQuery({ destination: undefined });
  }, [isUserAuthenticated, pathname, query.destination, search, setQuery]);

  if (isUserAuthenticated) {
    return <AcceptInvitation />;
  }

  if (!isUserAuthenticated) {
    return (
      <LoginOrRegister
        title={`You have been invited to join ${
          bandInvitation?.band?.title || "a band"
        }`}
      />
    );
  }

  return <Loader />;
};
